module.exports = __webpack_public_path__ + "static/media/TarjetaDebito.d9e82d56.svg";